import type { SYSTableDefIds } from "../../../../../../../_ovlclient/src"
import { html } from "../../../../../../../_ovlclient/src"
import { DialogOpen } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { FormHandlingType } from "../../../../../../../_ovlclient/src/library/dialog/sysdialogbase"
import { FieldVal } from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormGet,
  FormInit,
  FormIsValid,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { SYSBaseElement } from "../../../../../../../_ovlclient/src/library/sysbaseelement"
import { TableGet } from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import { BPFilterFields } from "../../../components/bpfilter/formdef"
import { EditLocked, OpenTableUploadEdit } from "./helpers"

export class ScreenOfferingAdminCut extends SYSBaseElement {
  offeringToolState: typeof this.state.app.features.QUTOffering

  async init() {
    this.offeringToolState = this.state.app.features.QUTOffering
    await super.init()
  }
  openAdminUpload = async () => {
    // if opened from here its always a new table
    // still we need to contact server for the schema
    let tb = TableGet("QUTOfferingPos")
    await tb.refresh({
      localData: [],
      forcedFilters: { staticFilter: { U_DocEntry: -1 } },
      resetStrategy: { ClearData: true },
    })
    await FormInit(
      "SYSEdit",
      {
        SYSEdit_Commission: {
          type: "text",
          schema: { nullable: false },
          ui: { labelTranslationKey: "GENCommission" },
        },
        CardCode: {
          type: "text",
          value: FieldVal(FormGet("QUTBPFilter").fields["CardCode"]),
          ui: { visible: "false", fillSpaceIfNotVisible: false },
        },
        CntctCode: {
          type: "text",
          list: {
            displayField: "CntctName",
            valueField: "CntctCode",
            displayValueField: false,
            mode: "List",
            serverEndpoint: "offering/bp_contacts",
            onlyRefreshFromServerIfOlderThanMs: 10000,
            tryGetLookupFromServerInFormInitIfNotFound: true,
          },
          schema: { nullable: false },
          ui: {
            labelTranslationKey: "QUTOfferingColOfferingCntctName",
          },
        },
      },
      {
        feature: "QUTOfferingPos",
        formId: "QUTOfferingPos",
        forceOverwrite: true,
      }
    )
    this.state.app.features.QUTOffering.cutListDirty = false
    this.state.app.features.QUTOffering.cutFileName = ""
    DialogOpen("QUTOfferingPos")
  }

  async getUI() {
    let uploadDisabled = EditLocked()
    let uploadHtml = html`
      <div class="fd-file-uploader offering-uploader">
        <button
          ?disabled=${uploadDisabled ||
          !FormIsValid(FormGet("QUTBPFilter").formState)}
          @click=${async () => await this.openAdminUpload()}
          id="asset_browse_button1"
          class="fd-button"
          aria-label="file auswählen"
        >
          <span class="fd-button__text"
            >${T("QUTOfferingOfferingNewOffer")}</span
          >
          <i class="sap-icon--upload"></i>
        </button>
      </div>
    `
    BPFilterFields.CardCode.value = this.state.ovl.user.cardCode
    return html`
      <div class="ovl-smart-screen-margins">
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
          <div class="fd-layout-panel__head">
            <h3 class="fd-layout-panel__title">
              <b>${T("QUTOfferingOfferingAdminCut")}</b>
            </h3>
          </div>
          <div class="fd-layout-panel__actions">
            <h4 class="fd-layout-panel__title">
              ${T("QUTOfferingOfferingAdminSelectCustomer")}
            </h4>
            <comp-genbpfilter
              .formHandling=${<FormHandlingType>{
                formType: "QUTBPFilter",
                autoInit: true,
                creation: {
                  autoInitFormFields: BPFilterFields,
                },
              }}
            ></comp-genbpfilter>
            ${uploadHtml}
          </div>
        </div>

        <div class="fd-layout-panel__body">
          <ovl-table
            class="fd-table offering-table"
            .props=${() => <SYSTableDefIds>"QUTOffering"}
          >
          </ovl-table>
        </div>
      </div>
      </div>
    `
  }
}
